"use client"

import ProductLabel from "@/components/common/ProductLabel"
import ProductSizeButton from "@/components/common/ProductSizeButton"
import { useSelectedVariant } from "@/hooks/product_detail/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Col, Row, Tooltip } from "antd"

const ProductSizes = () => {
  const attributes = useAppSelector(state => state.product.design_detail.data?.layout?.attributes)
  const sizeAttributeIds = useAppSelector(state => state.product.design_detail.data.attributeIds['size'] || [])
  const sizeAttributesData = useAppSelector(state => state.product.design_detail.data.attributesData['size'] || {})
  const variantsMapping = useAppSelector(state => state.product.design_detail.data.attributesVariantsMapping['size'] || {})
  const sizeSetting = useAppSelector(state => state.store.store_setting.data.sizes_selection)
  const selectedVariant = useSelectedVariant()

  const dispatch = useAppDispatch()

  if (!attributes || !attributes.includes("size")) {
    return <></>
  }

  return (
    <>
      <Row>
        <ProductLabel
          labelSetting={sizeSetting.label}
        />
      </Row>
      <Row gutter={[10, 10]}>
        {sizeAttributeIds.map((attrId) => {
          const size = sizeAttributesData[attrId]
          const variants = variantsMapping[size.id] || []

          return (
            <Col key={size.id}>
              <ProductSizeButton
                onClick={() => dispatch(productActions.selectVariant({
                  type: "size",
                  value: size.id
                }))}
                shape={"round"}
                ghost={!variants.includes(`${selectedVariant.id}`)}
              >
                {size.label}
              </ProductSizeButton>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductSizes